export class ServiceWorkerUtils {
    static unregisterIOS17() {

        // navigator.serviceWorker.getRegistrations().then(function (registrations) {
        //     for (let registration of registrations) {
        //         registration.unregister();
        //     }
        // });

        if (navigator.userAgent.toUpperCase().includes("LIKE MAC")) {
            if (navigator.userAgent.includes("Version/17.0") || navigator.userAgent.includes("Version/17.1")) {
                navigator.serviceWorker.getRegistrations().then(function (registrations) {
                    for (let registration of registrations) {
                        registration.unregister();
                    }
                });
            }
        }
    }

    static activeInPlatform(): boolean {
        return (!navigator.userAgent.toUpperCase().includes("LIKE MAC")
            ? true
            : ((navigator.userAgent.includes("Version/17.0") || navigator.userAgent.includes("Version/17.1")) ?
                false : true))
    }
}
